import {Suspense} from 'react';
import UbiDetailContentsLoading from '@di-shared/features/ubi/UbiDetailContentsLoading';
import UbiDetailContents from '@di-shared/features/ubi/UbiDetailContents';

export interface UbiDetailPageProps {
  vin: string;
  serviceId: string;
}

function UbiDetailPage({vin, serviceId}: UbiDetailPageProps) {
  return (
    <Suspense fallback={<UbiDetailContentsLoading />}>
      <UbiDetailContents
        vin={vin}
        serviceId={serviceId}
      />
    </Suspense>
  );
}

export default UbiDetailPage;
